
@if (tabs()) {
  <div [attr.data-testid]="'main-layout-window-tabs-group-' + windowIndex()" class="tab-group" cdkDropList [id]="dropListID()" [cdkDropListConnectedTo]="connectedDropLists()" [cdkDropListData]="windowIndex()" (cdkDropListDropped)="onDrop($event)" cdkDropListOrientation="horizontal">
    @for (tab of tabsBeforeOverflow(); track tab) {
      <button [attr.data-testid]="'main-layout-window-tabs-tab-' + tab.label" (click)="setSelected($index)" [class.selected]="$index === activeTabIndex()" class="tab text-overflow" [class.home-tab]="tab.type == 'home'" [title]="getTooltipForTab(tab.id)" [class.home]="tab.type === 'home'" [cdkContextMenuTriggerFor]="contextMenu" cdkDrag (cdkDragStarted)="globalDraggedTab.set({windowIndex: windowIndex(), tabIndex: $index})" (cdkDragEnded)="globalDraggedTab.set(null)">
        <div class="tab-icon">
          @switch (tab.type) {
            @case ('home') { <mat-icon>home</mat-icon> }
            @case ('customer') { <mat-icon>factory_filled</mat-icon> }
            @case ('order') { <mat-icon>note_alt_filled</mat-icon> }
            @case ('article') {
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
                <path d="M0 0H12L9 4.2V17L6 20L3 17V4.2L0 0ZM5 8H7V3.6L8 2H4L5 3.6V8ZM7 10H5V12H7V10ZM7 16V14H5V16L6 17L7 16Z" fill="white"/>
              </svg>
            }
          }
        </div>
        @if (tab.type !== 'home') {
          <div class="">
          </div>
          {{ getTabLabel(tab.id)() || tab.fallbackLabel }}
          <button [attr.data-testid]="'main-layout-window-tabs-tab-close-' + tab.label" (click)="$event.stopPropagation(); close(tab.id)" class="invisible reveal" title="Close tab" aria-label="Close tab">
            <ngt-button matIcon="close" scale="mini" shape="square" styling="tertiary" />
          </button>
        }
      </button>
      <ng-template #contextMenu>
        <div class="context-menu" cdkMenu>
          @if (tab.type !== 'home') {
            <button class="context-menu-item" (click)="close(tab.id)" cdkMenuItem>{{('windowtabs:close' | translate)()}}</button>
          }
          <button class="context-menu-item" (click)="closeOthers(tab.id)" cdkMenuItem>{{('windowtabs:closeOthers' | translate)()}}</button>
          <button class="context-menu-item" (click)="closeRight(tab.id)" cdkMenuItem>{{('windowtabs:closeRight' | translate)()}}</button>
          <button class="context-menu-item" (click)="closeLeft(tab.id)" cdkMenuItem>{{('windowtabs:closeLeft' | translate)()}}</button>
        </div>
      </ng-template>
    }
    @if (overflowing()) {
      @if (overflowedTabSelected() ? tabs()[activeTabIndex()] : tabs()[overflowBreakPoint()]; as tab) {
        <button [matMenuTriggerFor]="overflowDropdown" class="tab" [class.selected]="overflowedTabSelected()" [title]="getTooltipForTab(tab.id)" [class.home]="tab.type === 'home'">
           <div class="tab-icon">
             @switch (tab.type) {
               @case ('home') { <mat-icon>home</mat-icon> }
               @case ('customer') { <mat-icon>factory_filled</mat-icon> }
               @case ('order') { <mat-icon>note_alt_filled</mat-icon> }
               @case ('article') { <img src="img/article.svg" alt="Article" width="12" height="20" /> }
             }
           </div>
          <div class="flex-grow text-overflow">
            {{ getTabLabel(tab.id)() || tab.fallbackLabel }}
          </div>
          <button class="invisible reveal">
            <ngt-button matIcon="arrow_drop_down" scale="mini" shape="square" styling="tertiary" />
          </button>
        </button>
      }
      <mat-menu #overflowDropdown>
        @for (tab of tabsAfterOverflow(); track tab) {
          <button [attr.data-testid]="'main-layout-window-tabs-overflow-tab-' + tab.label" class="tab" [class.home]="tab.type === 'home'" [title]="getTooltipForTab(tab.id)" (click)="setOverflowedSelected($index)" [cdkContextMenuTriggerFor]="contextMenu">
            <div class="tab-icon">
              @switch (tab.type) {
                @case ('home') { <mat-icon>home</mat-icon> }
                @case ('customer') { <mat-icon>factory_filled</mat-icon> }
                @case ('order') { <mat-icon>note_alt_filled</mat-icon> }
                @case ('article') { <img src="img/article.svg" width="12" height="20" /> }
              }
            </div>
            <div class="flex-grow-row text-overflow align-left">
              {{ getTabLabel(tab.id)() || tab.fallbackLabel }}
            </div>
            @if (tab.type !== 'home') {
              <button [attr.data-testid]="'main-layout-window-tabs-overflow-tab-close-' + tab.label" (click)="$event.stopPropagation(); close(tab.id)" class="invisible reveal" title="Close tab" aria-label="Close tab">
                <ngt-button matIcon="close" scale="mini" shape="square" styling="tertiary" />
              </button>
            }
          </button>
          <ng-template #contextMenu>
            <div class="context-menu" cdkMenu>
              @if (tab.type !== 'home') {
                <button class="context-menu-item" (click)="close(tab.id)" cdkMenuItem>{{('windowtabs:close' | translate)()}}</button>
              }
              <button class="context-menu-item" (click)="closeOthers(tab.id)" cdkMenuItem>{{('windowtabs:closeOthers' | translate)()}}</button>
              <button class="context-menu-item" (click)="closeRight(tab.id)" cdkMenuItem>{{('windowtabs:closeRight' | translate)()}}</button>
              <button class="context-menu-item" (click)="closeLeft(tab.id)" cdkMenuItem>{{('windowtabs:closeLeft' | translate)()}}</button>
            </div>
          </ng-template>
        }
      </mat-menu>
    }
  </div>
}
